import React from 'react';
import { ToggleLeftIcon, HashIcon, BookmarkCheckIcon, CalendarIcon, ListIcon } from 'lucide-react';
const AttributesList = ({
  attributes,
  onEdit
}) => {
  if (!attributes.length) {
    return <p className="text-gray-500 italic" data-id="element-114">No attributes added yet.</p>;
  }
  // Function to get the appropriate icon based on data type
  const getDataTypeIcon = dataType => {
    if (dataType.startsWith('Yes/No')) {
      return <ToggleLeftIcon className="h-5 w-5" data-id="element-115" />;
    } else if (dataType.startsWith('Number')) {
      return <HashIcon className="h-5 w-5" data-id="element-116" />;
    } else if (dataType.startsWith('Text')) {
      return <BookmarkCheckIcon className="h-5 w-5" data-id="element-117" />;
    } else if (dataType.startsWith('Date')) {
      return <CalendarIcon className="h-5 w-5" data-id="element-118" />;
    } else if (dataType.startsWith('List')) {
      return <ListIcon className="h-5 w-5" data-id="element-119" />;
    } else {
      return <BookmarkCheckIcon className="h-5 w-5" data-id="element-120" />;
    }
  };
  // Function to get color class based on data type
  const getDataTypeColorClass = dataType => {
    if (dataType.startsWith('Yes/No')) {
      return 'bg-green-50 text-green-700 border-green-200';
    } else if (dataType.startsWith('Number')) {
      return 'bg-blue-50 text-blue-700 border-blue-200';
    } else if (dataType.startsWith('Text')) {
      return 'bg-purple-50 text-purple-700 border-purple-200';
    } else if (dataType.startsWith('Date')) {
      return 'bg-amber-50 text-amber-700 border-amber-200';
    } else if (dataType.startsWith('List')) {
      return 'bg-indigo-50 text-indigo-700 border-indigo-200';
    } else {
      return 'bg-gray-50 text-gray-700 border-gray-200';
    }
  };
  // Function to display data type label
  const getDataTypeLabel = dataType => {
    if (dataType.startsWith('List:')) {
      return 'List';
    }
    return dataType;
  };
  return <div className="space-y-4" data-id="element-121">
      {attributes.map(attribute => <div key={attribute.id} className={`flex justify-between p-4 border rounded-md hover:bg-opacity-80 ${getDataTypeColorClass(attribute.dataType)}`} data-id="element-122">
          <div className="flex items-center" data-id="element-123">
            <div className="mr-3" data-id="element-124">{getDataTypeIcon(attribute.dataType)}</div>
            <div data-id="element-125">
              <h3 className="font-medium" data-id="element-126">{attribute.name}</h3>
              <span className="text-xs opacity-75" data-id="element-127">
                {getDataTypeLabel(attribute.dataType)}
              </span>
              {attribute.dataType.startsWith('List:') && <div className="text-xs mt-1 opacity-75" data-id="element-128">
                  {attribute.dataType.substring(6).trim()}
                </div>}
            </div>
          </div>
          <div className="flex items-center" data-id="element-129">
            <button className="text-gray-600 hover:text-gray-800" onClick={() => onEdit(attribute.id)} data-id="element-130">
              <span className="sr-only" data-id="element-131">Edit</span>
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-132">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" data-id="element-133" />
              </svg>
            </button>
          </div>
        </div>)}
    </div>;
};
export default AttributesList;